import { initReactI18next } from 'react-i18next';
import i18next from 'i18next';
import enTranslation from './en.json';
import svTranslation from './sv.json';

// import LanguageDetector from 'i18next-browser-languagedetector';
const language = JSON.parse(localStorage.getItem('lang'));
let browserLanguage = window.navigator.language;
if (browserLanguage !== 'sv' && browserLanguage !== 'en') {
  browserLanguage = 'en';
}
const resources = {
  en: enTranslation,
  sv: svTranslation,
};

i18next
  .use(initReactI18next)

  .init({
    resources,
    lng: language || browserLanguage,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18next;
